import { SelectionState } from 'draft-js';
import getRangesForDraftEntity from 'draft-js/lib/getRangesForDraftEntity';

export const getCurrentEntity = (editorState) => {
  const contentState = editorState.getCurrentContent();
  const selection = editorState.getSelection();

  const block = contentState.getBlockForKey(selection.getStartKey());
  const entityKey = block.getEntityAt(selection.getStartOffset());

  if (!entityKey) {
    return null;
  }

  return editorState.getCurrentContent().getEntity(entityKey);
};

export const getSelectStateForEntity = (editorState) => {
  const contentState = editorState.getCurrentContent();
  const selection = editorState.getSelection();

  const selectionKey = selection.getStartKey();
  const selectionOffset = selection.getStartOffset();

  const block = contentState.getBlockForKey(selectionKey);
  const blockKey = block.getKey();

  const entityKey = block.getEntityAt(selection.getStartOffset());

  if (!entityKey) {
    return null;
  }

  let entitySelection;
  getRangesForDraftEntity(block, entityKey).forEach((range) => {
    if (range.start <= selectionOffset && selectionOffset <= range.end) {
      entitySelection = new SelectionState({
        anchorOffset: range.start,
        anchorKey: blockKey,
        focusOffset: range.end,
        focusKey: blockKey,
        isBackward: false,
        hasFocus: selection.getHasFocus(),
      });
    }
  });

  return entitySelection;
};

export const createLink = (editorState, url) => {
  const contentState = editorState.getCurrentContent();
  return contentState
    .createEntity('LINK', 'MUTABLE', {
      url,
    })
    .getLastCreatedEntityKey();
};
